var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningsmessagenoti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4876 12.0015L9.15426 2.66812C9.03797 2.46292 8.86933 2.29224 8.66555 2.1735C8.46176 2.05475 8.23012 1.99219 7.99426 1.99219C7.7584 1.99219 7.52677 2.05475 7.32298 2.1735C7.11919 2.29224 6.95055 2.46292 6.83426 2.66812L1.50093 12.0015C1.38338 12.205 1.32175 12.4361 1.32227 12.6711C1.32279 12.9062 1.38545 13.137 1.50389 13.34C1.62234 13.5431 1.79236 13.7112 1.99673 13.8273C2.20109 13.9435 2.43253 14.0036 2.6676 14.0015H13.3343C13.5682 14.0012 13.7979 13.9394 14.0005 13.8223C14.203 13.7052 14.3711 13.5368 14.4879 13.3342C14.6048 13.1315 14.6663 12.9017 14.6662 12.6678C14.6662 12.4338 14.6046 12.204 14.4876 12.0015Z",
    stroke: "#D97706",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.66667",
    stroke: "#D97706",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.332H8.00667",
    stroke: "#D97706",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningsmessagenoti);
export default __webpack_public_path__ + "static/media/Warnings message noti.3daf27346716479540f7bb1e89be5f97.svg";
export { ForwardRef as ReactComponent };